import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Layout from '../../components/ui/Layout';
import Button from '../../components/ui/Button';
import { IconPlus } from '@tabler/icons-react';

export default function MyQualifications() {
  const { userProfile } = useAuth();
  const navigate = useNavigate();
  return (
    <Layout>
      <div style={{ padding: 'var(--main-padding)', maxWidth: 560, margin: '0 auto' }}>
        <h1 style={{ fontSize: 22, fontWeight: 400, marginBottom: 8 }}>My qualifications</h1>
        <p style={{ fontSize: 13, color: 'var(--color-text-tertiary)', marginBottom: 24 }}>
          View your tickets and certificates
        </p>
        <Button
          variant="secondary"
          icon={<IconPlus size={14} stroke={1.5} />}
          onClick={() => navigate('/staff/' + userProfile?.id)}
        >
          View on staff profile
        </Button>
      </div>
    </Layout>
  );
}